import { TweenLite, Power1 } from "gsap/TweenMax";
import { Video } from '../blocks/video';
import 'animation.gsap'

export default class videoColumns {

  init() {
    this.root  = document.getElementById('container');
    this.body  = document.body;
    this.pages = document.querySelectorAll(".image-video-columns__modal");
    this.tiles = document.querySelectorAll(".image-video-columns__video-thumb");

    for (var i = 0; i < this.tiles.length; i++) {
      this.pages[i].video = new Video(this.pages[i]);
      this.addListeners(this.tiles[i], this.pages[i]);
    }
  }

  addListeners(tile, page) {
    this.animateHero = this.animateHero.bind(this)
    tile.addEventListener("click", () => { tile.video.playVideo(); } );
    $(page).on("stopvideo", () => { this.animateHero(page, tile) } );
  }

  isMobile() { //TODO: add this globaly somewhere
    return true;
    //return $('.mobile-check').is(':visible');
  }
// this need to change from click 'close' to pause video
  animateHero(fromHero, toHero) {

    if( this.isMobile() ) {

      if(fromHero.classList.contains('image-video-columns__modal')) {

        $(fromHero).data('cursor', 'pointer--play');
        if( fromHero.video.isPlaying ) {
         // $('.video__thumb--hidden').addClass('video__thumb--hidden');
         // fromHero.video.stopVideo();
        } else {
         // $('.video__thumb--hidden').removeClass('video__thumb--hidden');
          fromHero.video.playVideo();
        }
      }

      return;
    }

    var isOpening = !toHero.classList.contains('image-video-columns__modal');

    if(isOpening) {
      TweenLite.set(toHero, { visibility: "visible" });

      $(clone).find('img').removeClass('video__thumb--hidden');
    }

    var clone = fromHero.cloneNode(true);
    $(clone).addClass('clone');

    setTimeout(() => {
      $(clone).addClass('clone--transitioning');
    }, 0.2);

    var from = this.calculatePosition(fromHero);
    var to = this.calculatePosition(toHero);

    clone.style.zIndex = '999999999';
    clone.style.paddingBottom = '0';
    TweenLite.set([fromHero, toHero], { visibility: "hidden" });
    TweenLite.set(clone, { position: "absolute", margin: 0, visibility: "visible" });
    this.body.appendChild(clone);
    this.onComplete = this.onComplete.bind(this);
    this.root.addClass = 'container--video-playing';

    if(isOpening) {
      $(clone).find('img').removeClass('video__thumb--hidden');
    }

    var style = {
      x: to.left - from.left,
      y: to.top - from.top,
      width: to.width,
      height: to.height,
      autoRound: false,
      ease: Power1.easeOut,
      onComplete: () => {
        this.onComplete(toHero, clone, fromHero);
      },
    }

    TweenLite.set(clone, from);
    TweenLite.to(clone, 0.3, style)

  }

  onComplete(toHero, clone) {

    TweenLite.set(toHero, { visibility: "visible" });
    this.body.removeChild(clone);
    if(toHero.classList.contains('image-video-columns__modal')) {
      toHero.video.playVideo();
      document.body.classList.add('noscroll');
      $(toHero).data('cursor', ' ');

    } else {
      $('.video__thumb--hidden').removeClass('video__thumb--hidden');
      //fromHero.video.stopVideo();
      window.cursor.changeCursor('pointer--play');
      this.root.removeClass = 'container--video-playing';
      document.body.classList.remove('noscroll');
    }
  }
  calculatePosition(element) {

    var rect = element.getBoundingClientRect();

    var scrollTop  = window.pageYOffset || this.root.scrollTop  || this.body.scrollTop  || 0;
    var scrollLeft = window.pageXOffset || this.root.scrollLeft || this.body.scrollLeft || 0;

    var clientTop  = this.root.clientTop  || this.body.clientTop  || 0;
    var clientLeft = this.root.clientLeft || this.body.clientLeft || 0;

    return {
      top: Math.round(rect.top + scrollTop - clientTop),
      left: Math.round(rect.left + scrollLeft - clientLeft),
      height: rect.height,
      width: rect.width,
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/image_video-columns.js